import {Button} from 'components/Button';
import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {TPropsWithClassName} from 'core/types';
import {MODALS} from 'modules/modals/constants';
import {showModal} from 'modules/modals/thunks';
import {FC} from 'react';
import Icon from 'components/Icon';
import style from './style.module.scss';
import cs from 'classnames';
import {useIsLoggedIn} from 'modules/user/hooks/useIsLoggedIn';
import {showAuthDialog} from 'modules/auth/thunks';

export const BUTTON_VARIANTS = {
    ICON: 'ICON',
    TEXT: 'TEXT',
} as const;

type TButtonVariants = keyof typeof BUTTON_VARIANTS;

interface IProps {
    buttonVariant?: TButtonVariants;
    isStretched?: boolean;
}

export const CreateProductReviewDialog: FC<TPropsWithClassName<IProps>> = ({
    className,
    buttonVariant = BUTTON_VARIANTS.ICON,
    isStretched,
}) => {
    const dispatch = useAppDispatch();
    const isLoggedIn = useIsLoggedIn();

    const handleOpenModal = () => {
        if (isLoggedIn) {
            dispatch(showModal(MODALS.CREATE_PRODUCT_REVIEW.name));
        } else {
            dispatch(showAuthDialog);
        }
    };

    const submitButton = {
        [BUTTON_VARIANTS.ICON]: (
            <Button
                backColor={'red'}
                className={cs(className, style.writeReviewButton)}
                isStretched={isStretched}
                size={'large'}
                leftIcon={<Icon icon={'pencil-outbox'} />}
                onClick={handleOpenModal}
            />
        ),
        [BUTTON_VARIANTS.TEXT]: (
            <Button
                backColor={'red'}
                size={'large'}
                className={cs(className, style.writeReviewButton)}
                isStretched={isStretched}
                onClick={handleOpenModal}
            >
                Написать отзыв
            </Button>
        ),
    }[buttonVariant];

    return <>{submitButton}</>;
};
